var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16,0C 7.164,0,0,7.164,0,16s 7.164,16, 16,16s 16-7.164, 16-16C 32,7.162, 24.836,0, 16,0z M 23.96,12.408 c 0.008,0.17, 0.012,0.34, 0.012,0.51c0,5.206-3.962,11.208-11.208,11.208c-2.224,0-4.294-0.652-6.038-1.77 c 0.308,0.036, 0.622,0.056, 0.94,0.056c 1.846,0, 3.544-0.63, 4.892-1.686c-1.724-0.032-3.178-1.172-3.68-2.736 C 9.12,18.036, 9.364,18.060, 9.62,18.060c 0.36,0, 0.708-0.048, 1.038-0.138C 8.856,17.56, 7.498,15.968, 7.498,14.060c0-0.016,0-0.032,0-0.050 c 0.532,0.296, 1.138,0.472, 1.784,0.494C 8.226,13.798, 7.53,12.592, 7.53,11.226c0-0.722, 0.194-1.398, 0.532-1.98 c 1.942,2.384, 4.846,3.952, 8.12,4.116C 16.114,13.074, 16.080,12.772, 16.080,12.464c0-2.174, 1.764-3.938, 3.94-3.938 c 1.132,0, 2.156,0.478, 2.876,1.244c 0.898-0.178, 1.742-0.506, 2.502-0.956c-0.294,0.92-0.918,1.692-1.732,2.18 c 0.796-0.094, 1.556-0.308, 2.262-0.62C 25.4,11.162, 24.73,11.856, 23.96,12.408z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.cf2aca1ac171f63add8ea6d3151975c7.svg";
export { ForwardRef as ReactComponent };